import { BaseModel } from 'core/base.model';

import { TMeasureUnitType } from '../../types/measure-unit.type';

export class TechnicalSheet extends BaseModel {
  recipeCode: string = '0';
  recipeName: string = '';
  portions: number = 0;
  portionCost: number = 0;
  salePrice: number = 0;
  items: TechnicalSheetItem[] = [];

  static build(dto: TechnicalSheet) {
    const entity = new TechnicalSheet(dto.id, dto.createdAt, dto.updatedAt);
    entity.recipeCode = `${dto.recipeCode}`;
    entity.recipeName = dto.recipeName;
    entity.portions = dto.portions * 1.0;
    entity.portionCost = dto.portionCost * 1.0;
    entity.salePrice = dto.salePrice * 1.0;
    entity.items = TechnicalSheetItem.buildItems(dto.items);
    if (!entity.recipeName) throw new Error('Informe o nome da receita.');
    if (!entity.portions) throw new Error('Informe o número de porções.');
    return entity;
  }
}

export class TechnicalSheetItem {
  productId: string = '';
  groupItem: string = 'Receita';
  recipeQuantity: number = 0;
  measureUnit: TMeasureUnitType = '';

  static build(dto: TechnicalSheetItem) {
    const entity = new TechnicalSheetItem();
    entity.productId = dto.productId;
    entity.groupItem = dto.groupItem;
    entity.recipeQuantity = dto.recipeQuantity * 1.0;
    entity.measureUnit = dto.measureUnit;
    if (!entity.productId) throw new Error('Informe o produto.');
    if (!entity.groupItem) throw new Error('Informe o grupo (ex: Receita, Massa, Cobertura).');
    if (!entity.recipeQuantity || entity.recipeQuantity <= 0)
      throw new Error('Informe uma quantidade maior que zero.');
    if (!entity.measureUnit) throw new Error('Informe a nidade de medida.');
    return entity;
  }

  static buildItems(dtos: TechnicalSheetItem[]) {
    const entities = dtos.map(dto => this.build(dto));
    return entities;
  }
}
